import React, { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { PersistentFooterContext } from "../../../Mobile/Footer/persistentFooterContext";
import "./bottomNav.css";

// Icons exported from the "Zaapit partner app" Figma (public/assets/img/delivery/partner).
const ICON_BASE = "/assets/img/delivery/partner";

const NAV_ITEMS = [
  { key: "home", label: "Home", path: "/delivery/home", icon: "nav-home" },
  { key: "orders", label: "Orders", path: "/delivery/orders", icon: "nav-orders" },
  { key: "earned", label: "Earned", path: "/delivery/earnings", icon: "nav-earned" },
  { key: "profile", label: "Me", path: "/delivery/profile", icon: "nav-me" },
];

const DeliveryBottomNav = ({ forcedActiveKey = "", persistentChrome = false }) => {
  const history = useHistory();
  const location = useLocation();
  const inPersistentShell = useContext(PersistentFooterContext);

  if (inPersistentShell && !persistentChrome) {
    return <div className="delivery-bottom-nav-spacer" aria-hidden="true" />;
  }

  return (
    <div className="delivery-bottom-nav">
      {NAV_ITEMS.map((item) => {
        const isActive = forcedActiveKey
          ? forcedActiveKey === item.key
          : item.path &&
            (location.pathname === item.path ||
              (item.key === "profile" && location.pathname === "/delivery/me"));
        return (
          <button
            key={item.key}
            type="button"
            className={`delivery-bottom-nav__item ${isActive ? "delivery-bottom-nav__item--active" : ""}`}
            onClick={() => item.path && history.push(item.path)}
            disabled={!item.path}
          >
            {/* Masked so the icon takes the text colour — grey, or pink when active. */}
            <span
              className="delivery-bottom-nav__icon"
              aria-hidden="true"
              style={{
                WebkitMaskImage: `url(${ICON_BASE}/${item.icon}.svg)`,
                maskImage: `url(${ICON_BASE}/${item.icon}.svg)`,
              }}
            />
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default DeliveryBottomNav;
